export function buildEmployeeLoginPath(): string {
  return '/employee/login';
}

export function resolveEmployeeLoginPath(): string {
  return buildEmployeeLoginPath();
}

export function resolveEmployeeLoginPathFromUser(): string {
  return buildEmployeeLoginPath();
}

export function buildEmployeeForgotPasswordPath(): string {
  return '/employee/forgot-password';
}

export function buildEmployeeGoogleAuthPath(): string {
  return '/employee/auth/google';
}
